/* ==========================================================
   VITRINA — interacciones
   - Giro 360° con foco al pasar el cursor (tarjetas)
   - Visor arrastrable en página de producto
   - Carrito lateral con Ajax (API /cart de Shopify)
   - Encabezado, paneles, variantes, barra de compra fija
   ========================================================== */
(function () {
  'use strict';
  var VT = window.VT = window.VT || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var easeInOut = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  /* ---------------- Dinero ---------------- */
  VT.money = function (cents) {
    var fmt = VT.moneyFormat || '${{amount}}';
    var n = (cents || 0) / 100;
    var withDec = n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var noDec = Math.round(n).toLocaleString('es-MX');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount\s*\}\}/, withDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec);
  };

  /* ---------------- Toast ---------------- */
  var toastEl, toastT;
  VT.toast = function (msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  };

  /* ==========================================================
     MOTOR DE GIRO
     Con 1–7 imágenes: giro 3D (la cara se cambia al quedar de canto,
     así nunca se ve el reverso espejeado).
     Con 8+ imágenes marcadas "360": secuencia fotográfica real.
     ========================================================== */
  function Spinner(card, opts) {
    this.card = card;
    this.opts = opts || {};
    this.wrap = $('.vt-spin', card);
    this.img = $('.vt-spin img', card);
    this.sheen = $('.vt-sheen', card);
    this.shadow = $('.vt-shadow', card);
    this.floor = $('.vt-floor', card);
    if (!this.wrap || !this.img) return;
    var frames = [];
    try { frames = JSON.parse(card.getAttribute('data-frames') || '[]'); } catch (e) { }
    if (!frames.length) frames = [this.img.currentSrc || this.img.src];
    this.frames = frames;
    this.photo360 = frames.length >= 8;
    this.angle = 0; this.tilt = 0; this.raf = 0; this.current = 0;
    this.duration = parseInt(card.getAttribute('data-spin-ms') || VT.spinMs || 1500, 10);
    this.preload();
  }
  Spinner.prototype.preload = function () {
    var self = this;
    if (this._pre) return; this._pre = true;
    this.frames.forEach(function (src, i) { if (i) { var im = new Image(); im.decoding = 'async'; im.src = src; } });
    self.render();
  };
  Spinner.prototype.setFrame = function (i) {
    if (i === this.current) return;
    this.current = i;
    this.img.removeAttribute('srcset');
    this.img.src = this.frames[i];
  };
  Spinner.prototype.render = function () {
    var a = this.angle;
    if (this.photo360) {
      var n = this.frames.length;
      var idx = Math.floor((((a % 360) + 360) % 360) / 360 * n) % n;
      this.setFrame(idx);
      this.wrap.style.transform = 'rotateY(' + this.tilt + 'deg)';
      if (this.shadow) this.shadow.style.transform = 'scaleX(1)';
      return;
    }
    // giro 3D: segmentos de 180°, cada uno centrado al frente
    var seg = Math.floor((a + 90) / 180);
    var local = a - seg * 180;              // -90 … 90
    var faces = Math.min(this.frames.length, 2) || 1;
    var face = ((seg % faces) + faces) % faces;
    this.setFrame(face);
    var cos = Math.abs(Math.cos(local * Math.PI / 180));
    this.wrap.style.transform = 'rotateY(' + (local + this.tilt) + 'deg) scale(' + (1 + (1 - cos) * 0.04) + ')';
    if (this.shadow) this.shadow.style.transform = 'scaleX(' + (0.45 + 0.55 * cos) + ')';
    if (this.floor) this.floor.style.transform = 'scaleX(' + (0.8 + 0.2 * cos) + ')';
    // brillo de la pedrería al girar: más luz de frente, menos de canto
    this.img.style.setProperty('filter', this.card.classList.contains('is-lit') ? 'brightness(' + (0.75 + 0.35 * cos) + ') contrast(1.06) drop-shadow(0 22px 22px rgba(0,0,0,.6))' : '');
  };
  Spinner.prototype.spin = function (turns) {
    var self = this;
    if (reduce) { this.card.classList.add('is-lit'); return; }
    cancelAnimationFrame(this.raf);
    var start = performance.now(), from = this.angle % 360, to = from + 360 * (turns || 1);
    if (this.angle % 360 !== 0 && !this.photo360) { to = Math.ceil(from / 360) * 360 + 360 * ((turns || 1) - 1); if (to - from < 180) to += 360; }
    this.card.classList.add('is-spinning');
    var dur = this.duration * ((to - from) / 360);
    var step = function (t) {
      var p = Math.min(1, (t - start) / dur);
      self.angle = from + (to - from) * easeInOut(p);
      self.render();
      if (p < 1) self.raf = requestAnimationFrame(step);
      else { self.angle = 0; self.render(); self.card.classList.remove('is-spinning'); self.spinning = false; }
    };
    this.spinning = true;
    this.raf = requestAnimationFrame(step);
  };
  Spinner.prototype.light = function (on) { this.card.classList.toggle('is-lit', !!on); };
  Spinner.prototype.setTilt = function (deg) { this.tilt = deg; if (!this.spinning) this.render(); };
  VT.Spinner = Spinner;

  function initCards(root) {
    $$('[data-spin]', root).forEach(function (card) {
      if (card._sp) return;
      var sp = card._sp = new Spinner(card);
      if (!sp.wrap) return;
      var stage = $('.vt-stage', card);
      if (canHover) {
        stage.addEventListener('pointerenter', function () { sp.light(true); sp.spin(1); });
        stage.addEventListener('pointerleave', function () { sp.light(false); sp.setTilt(0); });
        stage.addEventListener('pointermove', function (e) {
          if (sp.spinning || reduce) return;
          var r = stage.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - .5;
          if (sp.photo360) { sp.angle = x * 360; sp.render(); }
          else sp.setTilt(x * 22);
        });
        stage.addEventListener('focus', function () { sp.light(true); sp.spin(1); });
        stage.addEventListener('blur', function () { sp.light(false); });
      } else if ('IntersectionObserver' in window) {
        // Táctil: la vitrina se enciende y gira cuando llega al centro de la pantalla
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (en.isIntersecting) { if (!card.classList.contains('is-lit')) { sp.light(true); sp.spin(1); } }
            else sp.light(false);
          });
        }, { rootMargin: '-35% 0px -35% 0px' });
        io.observe(card);
      }
    });
  }
  VT.initCards = initCards;

  /* ---------------- Visor de producto (arrastrar para girar) ---------------- */
  function initViewer() {
    var card = $('[data-viewer]'); if (!card) return;
    var sp = card._sp = new Spinner(card);
    var stage = $('.vt-stage', card);
    sp.light(true);
    setTimeout(function () { sp.spin(1); }, 350);
    var dragging = false, lastX = 0, vel = 0, inertia = 0;
    stage.addEventListener('pointerdown', function (e) {
      dragging = true; lastX = e.clientX; vel = 0; cancelAnimationFrame(inertia); cancelAnimationFrame(sp.raf); sp.spinning = false;
      stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lastX; lastX = e.clientX; vel = dx;
      sp.angle += dx * 0.7; sp.render();
    });
    var end = function () {
      if (!dragging) return; dragging = false;
      var glide = function () {
        vel *= 0.94; sp.angle += vel * 0.7; sp.render();
        if (Math.abs(vel) > 0.15) inertia = requestAnimationFrame(glide);
        else if (!sp.photo360) { // asentar al frente
          var target = Math.round(sp.angle / 180) * 180, from = sp.angle, t0 = performance.now();
          var settle = function (t) { var p = Math.min(1, (t - t0) / 380); sp.angle = from + (target - from) * easeInOut(p); sp.render(); if (p < 1) inertia = requestAnimationFrame(settle); };
          inertia = requestAnimationFrame(settle);
        }
      };
      glide();
    };
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { sp.angle -= 30; sp.render(); }
      if (e.key === 'ArrowRight') { sp.angle += 30; sp.render(); }
    });
    // miniaturas
    $$('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
        var src = b.getAttribute('data-thumb');
        var i = sp.frames.indexOf(src);
        if (i < 0) { sp.frames = [src].concat(sp.frames.filter(function (f) { return f !== src; })); i = 0; sp.current = -1; }
        if (!sp.photo360) { sp.frames = [sp.frames[i]].concat(sp.frames.filter(function (_, k) { return k !== i; })); sp.current = -1; sp.angle = 0; }
        sp.render(); sp.spin(1);
      });
    });
    VT.viewer = sp;
  }

  /* ---------------- Hero: secuencia de encendido + paralaje ---------------- */
  function initHero() {
    var hero = $('[data-hero]'); if (!hero) return;
    var caps = $$('.vt-hero__cap', hero);
    var order = [1, 0, 2];
    requestAnimationFrame(function () { hero.classList.add('is-on'); });
    order.forEach(function (idx, k) {
      var c = caps[idx]; if (!c) return;
      setTimeout(function () {
        c.classList.add('is-lit');
        if (!reduce) c.classList.add('is-flicker');
        if (VT.smoke) VT.smoke.lightOn(idx);
      }, reduce ? 0 : 350 + k * 520);
    });
    if (reduce || !canHover) return;
    var par = $$('.vt-hero__parallax', hero);
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      par.forEach(function (p, i) {
        var d = (i === 1 ? 18 : 30);
        p.style.transform = 'translate3d(' + (-x * d) + 'px,' + (-y * d * .6) + 'px,0) rotateY(' + (x * 10) + 'deg)';
      });
      if (VT.smoke) VT.smoke.pointer(x, y);
    });
  }

  /* ---------------- Encabezado y paneles ---------------- */
  function initHeader() {
    var h = $('.site-header');
    if (h) {
      var onScroll = function () { h.classList.toggle('is-scrolled', window.scrollY > 30); };
      onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    }
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-open]');
      if (open) { e.preventDefault(); VT.openPanel(open.getAttribute('data-open')); return; }
      var close = e.target.closest('[data-close]');
      if (close) { e.preventDefault(); VT.closePanels(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') VT.closePanels(); });
  }
  var lastFocus;
  VT.openPanel = function (id) {
    var p = document.getElementById(id); if (!p) return;
    VT.closePanels(true);
    lastFocus = document.activeElement;
    p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = $('input[type=search], button, a', $('.panel__body', p)); if (f) setTimeout(function () { f.focus(); }, 60);
    if (id === 'cart-drawer') VT.cart.refresh();
  };
  VT.closePanels = function (silent) {
    $$('.panel.is-open').forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
    document.documentElement.style.overflow = '';
    if (!silent && lastFocus) lastFocus.focus();
  };

  /* ==========================================================
     CARRITO
     ========================================================== */
  var mockCart = { items: [], item_count: 0, total_price: 0 };
  var api = {
    get: function () {
      if (VT.mock) return Promise.resolve(mockCart);
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    },
    add: function (id, qty, meta) {
      if (VT.mock) {
        var it = mockCart.items.filter(function (i) { return i.id == id; })[0];
        if (it) it.quantity += qty; else mockCart.items.push(Object.assign({ id: +id, key: 'k' + id, quantity: qty }, meta || VT.mockProducts[id]));
        return Promise.resolve(recalc());
      }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    },
    change: function (key, qty) {
      if (VT.mock) {
        mockCart.items = mockCart.items.map(function (i) { if (i.key === key) i.quantity = qty; return i; }).filter(function (i) { return i.quantity > 0; });
        return Promise.resolve(recalc());
      }
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
    }
  };
  function recalc() {
    mockCart.item_count = mockCart.items.reduce(function (a, i) { return a + i.quantity; }, 0);
    mockCart.total_price = mockCart.items.reduce(function (a, i) { i.final_line_price = i.price * i.quantity; return a + i.final_line_price; }, 0);
    return mockCart;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(url, w) { if (!url || VT.mock) return url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  VT.cart = {
    render: function (cart) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
      var box = $('[data-cart-body]'); if (!box) return;
      var t = VT.strings || {};
      var thr = VT.freeShipping || 0;
      var bar = '';
      if (thr > 0) {
        var left = thr - cart.total_price, pct = Math.min(100, cart.total_price / thr * 100);
        bar = '<div class="ship-bar">' + (left > 0 ? (t.shipLeft || 'Te faltan {x} para envío gratis').replace('{x}', '<strong>' + VT.money(left) + '</strong>') : (t.shipFree || 'Tu envío es gratis')) +
          '<div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
      }
      if (!cart.items.length) {
        box.innerHTML = bar + '<div class="cart-empty"><p class="panel__title">' + esc(t.empty || 'Tu carrito está vacío') + '</p><p>' + esc(t.emptySub || 'La vitrina te espera.') + '</p><a class="btn btn--gold" href="' + (VT.routes ? VT.routes.all : '#') + '" data-close>' + esc(t.browse || 'Ver gorras') + '</a></div>';
        return;
      }
      var items = cart.items.map(function (i) {
        var variant = i.variant_title && i.variant_title !== 'Default Title' ? '<div class="cart-item__variant">' + esc(i.variant_title) + '</div>' : '';
        return '<div class="cart-item" data-key="' + esc(i.key) + '">' +
          '<a class="cart-item__img" href="' + esc(i.url || '#') + '">' + (i.image ? '<img src="' + esc(sized(i.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div><p class="cart-item__title">' + esc(i.product_title || i.title) + '</p>' + variant +
          '<div class="qty"><button type="button" data-qty="-1" aria-label="Quitar uno">−</button><input type="number" min="0" value="' + i.quantity + '" aria-label="Cantidad" data-qty-input><button type="button" data-qty="1" aria-label="Agregar uno">+</button></div></div>' +
          '<div><div class="cart-item__price">' + VT.money(i.final_line_price) + '</div><button type="button" class="cart-item__remove" data-remove>' + esc(t.remove || 'Quitar') + '</button></div></div>';
      }).join('');
      var msi = VT.msiMonths > 1 ? '<small>' + (t.msi || 'o {n} pagos de {x}').replace('{n}', VT.msiMonths).replace('{x}', VT.money(Math.ceil(cart.total_price / VT.msiMonths))) + '</small>' : '';
      box.innerHTML = bar + '<div class="cart-items">' + items + '</div>' +
        '<div class="cart-foot"><div class="cart-foot__row"><span>' + esc(t.subtotal || 'Subtotal') + '</span><span>' + VT.money(cart.total_price) + '</span></div>' + msi +
        '<small>' + esc(t.taxes || 'Envío calculado al pagar.') + '</small>' +
        '<form action="' + (VT.routes ? VT.routes.cart : '#') + '" method="post"' + (VT.mock ? ' onsubmit="event.preventDefault()"' : '') + '><button class="btn btn--gold btn--block" type="submit" name="checkout">' + esc(t.checkout || 'Pagar ahora') + '</button></form>' +
        '<a class="btn btn--ghost btn--block" href="' + (VT.routes ? VT.routes.cart : '#') + '">' + esc(t.viewCart || 'Ver carrito') + '</a></div>';
    },
    refresh: function () { return api.get().then(VT.cart.render); },
    add: function (id, qty, btn, meta) {
      if (btn) btn.classList.add('is-loading');
      return api.add(id, qty || 1, meta).then(function () {
        return VT.cart.refresh().then(function () { VT.openPanel('cart-drawer'); });
      }).catch(function (err) {
        VT.toast((err && (err.description || err.message)) || 'No se pudo agregar. Intenta de nuevo.');
      }).then(function () { if (btn) btn.classList.remove('is-loading'); });
    }
  };

  function initCart() {
    var body = $('[data-cart-body]');
    if (body) {
      body.addEventListener('click', function (e) {
        var row = e.target.closest('[data-key]'); if (!row) return;
        var key = row.getAttribute('data-key'), input = $('[data-qty-input]', row);
        var q = e.target.closest('[data-qty]');
        if (q) { api.change(key, Math.max(0, +input.value + +q.getAttribute('data-qty'))).then(VT.cart.render); }
        if (e.target.closest('[data-remove]')) { row.style.opacity = .4; api.change(key, 0).then(VT.cart.render); }
      });
      body.addEventListener('change', function (e) {
        if (!e.target.matches('[data-qty-input]')) return;
        var row = e.target.closest('[data-key]');
        api.change(row.getAttribute('data-key'), Math.max(0, +e.target.value)).then(VT.cart.render);
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-quick-add]'); if (!b) return;
      e.preventDefault();
      VT.cart.add(b.getAttribute('data-quick-add'), 1, b);
    });
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('form[data-ajax-cart]'); if (!f) return;
      e.preventDefault();
      var id = f.querySelector('[name=id]').value, qty = +(f.querySelector('[name=quantity]') || { value: 1 }).value;
      VT.cart.add(id, qty, f.querySelector('[type=submit]'));
    });
    if (!VT.mock) VT.cart.refresh();
  }

  /* ---------------- Variantes ---------------- */
  function initProductForm() {
    var root = $('[data-product]'); if (!root) return;
    var json = $('[data-product-json]', root); if (!json) return;
    var product = JSON.parse(json.textContent);
    var form = $('form[data-ajax-cart]', root);
    var idInput = $('[name=id]', form);
    var priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root), msiEl = $('[data-msi]', root);
    var btn = $('[data-add]', root), sticky = $('[data-sticky-price]'), stickyBtn = $('[data-sticky-add]');
    var stockEl = $('[data-stock]', root);
    function selected() { return $$('.opt', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function update() {
      var sel = selected();
      var v = product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
      $$('.opt', root).forEach(function (fs, i) {
        $$('input', fs).forEach(function (inp) {
          var test = sel.slice(); test[i] = inp.value;
          var ok = product.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return o === test[k]; }); });
          inp.classList.toggle('is-unavailable', !ok);
        });
        var lab = $('[data-selected]', fs); if (lab) lab.textContent = sel[i] || '';
      });
      if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
      idInput.value = v.id;
      priceEl.textContent = VT.money(v.price);
      if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? VT.money(v.compare_at_price) : ''; }
      if (msiEl && VT.msiMonths > 1) msiEl.innerHTML = (VT.strings.msiPdp || 'o <strong>{n} meses</strong> de {x}').replace('{n}', VT.msiMonths).replace('{x}', VT.money(Math.ceil(v.price / VT.msiMonths)));
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-sold');
      if (sticky) sticky.textContent = VT.money(v.price);
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (stockEl) {
        var q = v.inventory_quantity;
        stockEl.classList.toggle('is-low', typeof q === 'number' && q > 0 && q <= 5);
        stockEl.querySelector('span').textContent = !v.available ? (VT.strings.soldOut || 'Agotado') : (typeof q === 'number' && q > 0 && q <= 5 ? (VT.strings.lowStock || 'Últimas {n} piezas').replace('{n}', q) : (VT.strings.inStock || 'Disponible, sale en 24–48 h'));
      }
      if (v.featured_image && VT.viewer) {
        var src = v.featured_image.src; VT.viewer.frames = [src].concat(VT.viewer.frames.filter(function (f) { return f.split('?')[0] !== src.split('?')[0]; })); VT.viewer.current = -1; VT.viewer.angle = 0; VT.viewer.render(); VT.viewer.spin(1);
      }
      if (!VT.mock && window.history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('.opt')) update(); });
    $$('.buy [data-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () { var i = $('[name=quantity]', root); i.value = Math.max(1, +i.value + +b.getAttribute('data-qty')); });
    });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : btn.click(); });
    var bar = $('.sticky-buy');
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { bar.classList.toggle('is-visible', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(btn);
      var wa = $('.wa'); if (wa) wa.classList.add('has-sticky');
    }
    update();
  }

  /* ---------------- Recomendaciones (Ajax) ---------------- */
  function initRecs() {
    $$('[data-recs]').forEach(function (el) {
      if (VT.mock) return;
      fetch(el.getAttribute('data-recs')).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var inner = d.querySelector('[data-recs]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; initCards(el); }
      });
    });
  }

  VT.reinitPage = function () { initCards(document); initViewer(); initProductForm(); };

  function boot() {
    initHeader(); initCards(document); initViewer(); initHero(); initCart(); initProductForm(); initRecs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initCards(e.target); initHero(); });
})();
